import { Injectable } from '@angular/core';
import {
  CreateMutationResult,
  injectMutation,
} from '@tanstack/angular-query-experimental';
import {
  ApiNewsletterService,
  SubscribeNewsletterDto,
} from '../api-newsletter/api-newsletter.service';

@Injectable({
  providedIn: 'root',
})
export class NewsletterService {
  constructor(private readonly apiNewsletterService: ApiNewsletterService) {}

  public subscribe(): CreateMutationResult<
    void,
    Error,
    SubscribeNewsletterDto
  > {
    return injectMutation(() => ({
      mutationFn: (variables: SubscribeNewsletterDto) =>
        this.apiNewsletterService.subscribe(variables),
    }));
  }
}
